import { NgModule } from '@angular/core';
import { NumberSpinnerComponent } from './number-spinner.component';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NumberOnlyDirective } from './number-only-directive';
import { PopoverModule } from '@farris/ui-popover';
import { NumberRangeComponent } from './number-range.component';
import { LocaleModule } from '@farris/ui-locale';
@NgModule({
    declarations: [
        NumberSpinnerComponent, NumberOnlyDirective,
        NumberRangeComponent
    ],
    imports: [
        CommonModule, FormsModule,
        PopoverModule.forRoot(),
        LocaleModule.forRoot()
    ],
    exports: [NumberSpinnerComponent, NumberOnlyDirective,
        NumberRangeComponent]
})
export class NumberSpinnerModule {}
